import { render, staticRenderFns } from "./PerfTable.vue?vue&type=template&id=106db0a8&scoped=true&"
import script from "./PerfTable.vue?vue&type=script&lang=js&"
export * from "./PerfTable.vue?vue&type=script&lang=js&"
import style0 from "./PerfTable.vue?vue&type=style&index=0&id=106db0a8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106db0a8",
  null
  
)

export default component.exports